import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import * as QRCode from 'qrcode';
import { isDateTime } from 'na-lib';
import { DppUrlService } from '../service/dpp-url.service';

@Component({
    selector: 'app-qr-code-dialog',
    templateUrl: './qr-code-dialog.component.html',
    styleUrls: ['./qr-code-dialog.component.css'],
    standalone: false
})
export class QrCodeDialogComponent {
  myAngularxQrCode: string
  QRdata:string = ""
  QRId:string
  nfcURLPrefix: any;
  QRimage:string
  QRname:string
  QRdataURL:string
  webUrl:string
  copyUrl:string
  hasDraft = false;
  previewMode: 'live' | 'draft' = 'live';
  private draftId = '';

  constructor(
    public dialogRef: MatDialogRef<QrCodeDialogComponent>,
    private dppUrlService: DppUrlService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
      this.myAngularxQrCode = environment.tagHostName

      if (environment.urlHostName === "api.narravero.dev") {
        this.webUrl = "https://nv2.at/";
      } else if (environment.urlHostName === "api.narravero.it") {
        this.webUrl = "https://nvtest.eu/";
      } else if (environment.urlHostName === "api.narravero.com") {
        this.webUrl = "https://nvero.app/";
      } else {
        //this.webUrl = "https://reader.narravero.com/";
        this.webUrl = "https://nvero.app/";
      }
     
      dialogRef.disableClose = true;
    }

ngOnInit() {
  this.QRId = this.data?.id;
  this.nfcURLPrefix = this.data?.nfcPrefix;
  this.QRname = this.data?.name ?? 'QR';
  this.draftId = String(this.data?.draftId || '');
  this.hasDraft = this.data?.hasDraft === true && !!this.draftId;

  this.updatePreviewUrl();
}

  setPreviewMode(mode: 'live' | 'draft'): void {
    this.previewMode = mode;
    this.updatePreviewUrl();
  }

  private updatePreviewUrl(): void {
  const liveUrl = this.dppUrlService.getTridyUrl(this.QRId, this.nfcURLPrefix);
  this.QRdata = this.previewMode === 'draft' && this.draftId
    ? this.withDraftPreview(liveUrl, this.draftId)
    : liveUrl;
  this.QRdataURL = this.QRdata;
  this.copyUrl = this.QRdata;

  QRCode.toDataURL(this.QRdata)
    .then(url => {
      this.QRimage = url;
    })
    .catch(err => console.error('Error generating QR code: ', err));
  }

  private withDraftPreview(url: string, draftId: string): string {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}draftId=${encodeURIComponent(draftId)}`;
  }

  closeQRDialog(){
    this.dialogRef.close()
  }

  downloadQR(){
    const link = document.createElement('a');
    link.href = this.QRimage;
    const date = new Date()
    const fileName = `${this.QRname.replace(' ', '')}_${ isDateTime(date)}.png`
    link.download = fileName;
    link.click();
  }

  openQRurl(){
    window.open(this.QRdataURL, "_blank");
  }
}
